import FindInvestorsHeader from './find-investors-modules/header';
import Pagination from '../../components/ui/pagination';
import InvestorsList from './find-investors-modules/investorsList';

const FindInvestors = ({
  filteredInvestors,
  totalResults,
  currentPage,
  itemsPerPage,
  onPageChange,
  isLoading = false,
}) => {
  const totalPages = Math.ceil((totalResults || 0) / (itemsPerPage || 10));

  return (
    <div>
      <FindInvestorsHeader allowWrap={false} />

      <div className="mt-8 mb-8">
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={onPageChange}
        />
      </div>

      <InvestorsList
        currentInvestors={filteredInvestors}
        isLoading={isLoading}
        pageSize={itemsPerPage || 10}
      />

      <div className="mt-8">
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={onPageChange}
        />
      </div>
    </div>
  );
};

export default FindInvestors;
